import { render, staticRenderFns } from "./ResponsibilityBadgeHoldersTab.vue?vue&type=template&id=4d54ed21&scoped=true"
import script from "./ResponsibilityBadgeHoldersTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityBadgeHoldersTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityBadgeHoldersTab.vue?vue&type=style&index=0&id=4d54ed21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d54ed21",
  null
  
)

export default component.exports